// extracted by mini-css-extract-plugin
module.exports = {"g1nrkimi":"g1nrkimi","bu47715":"bu47715","ljraie7":"ljraie7","l12tgnsh":"l12tgnsh"};